import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AuthService } from "../auth.service";
import { DataService } from "../data.service";
import { StudyReportRegionView } from "src/app/model/study-report/study-report-region-view";
import { StudyReportLockInfo } from "src/app/model/study-report-lock-info";
import { StudyReportTemplateFilter } from "src/app/model/study-report-template-filter";
import { StudyReportTemplateEdit } from "src/app/model/study-report-template-edit";
import { StudyReportSearchItem } from "src/app/model/study-report-search-item";
import { StudyReportReverseReason } from "src/app/model/study-report-reverse-reason";
import { ReportViewer } from "src/app/model/report-viewer";
import { StudyReportEdit } from "src/app/model/study-report-edit";
import { StudyReportReverse } from "src/app/model/study-rerport-reverse";
import {
  StructuredDiagnosisColumnItem,
  StudyReportEditInfo,
} from "src/app/model/study-report-text";
import { StudyReportStateFilter } from "../../model/study-report-state";
import { StudyReportReportViewer } from "../../model/study-report-report-viewer";
import { StudyRegionPhycisianResponse } from "src/app/model/study-report/study-report-phycisian-response";
import { StudyReportAttachedFileView } from "../../model/study-report/study-report-attached-file-view";
import { AdminControledRequest } from "src/app/model/study-report/admin-controled-request";
import { StudyReportTypeModalityEnum } from "src/app/model/study-report/study-report-type-modality";
import { StudyReportSections } from "src/app/model/study-report/study-report-sections";
import { SearchMedicalReportAuditRequest } from "src/app/model/study-report/search-medical-report-audit-request";
import { SearchMedicalReportAuditResponse } from "src/app/model/study-report/search-medical-report-audit-response";
import { SearchMedicalReportHistorialRequest } from "src/app/model/study-report/search-medical-report-historial-request";
import { SearchMedicalReportHistorialResponse } from "src/app/model/study-report/search-medical-report-historial-response";
import { SearchMedicalReportCategory } from "src/app/model/study-report/search-medical-report-category-response";

@Injectable()
export class StudyReportService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private dataService: DataService
  ) {}

  private readonly getStudyReportPdfEndPoint: string =
    "/studyReport/getStudyReportPdf/";
  private readonly getStudyReportHistorialEndPoint: string =
    "/studyReport/GetStudyReportHistorial/";
  private readonly getStudiesReportPdfEndPoint: string =
    "/studyReport/getStudiesReportPdf/";
  private readonly getMergedStudiesReportPdfEndPoint: string =
    "/studyReport/getMergedStudiesReportPdf/";
  private readonly getStudyReportIdStudiesReportPdfEndPoint: string =
    "/studyReport/getStudyReportIdStudiesReportPdf/";

  private readonly sendMassiveMailsEndPoint: string =
    "/studyReport/sendMassiveMails/";

  private readonly sendMailByIdEndPoint: string = "/studyReport/sendMailById/";
  private readonly sendMailEndPoint: string = "/studyReport/sendMail/";
  private readonly setReportPhysicianEndPoint: string =
    "/studyReport/setReportPhysician/";
  private readonly clearReportPhysicianEndPoint: string =
    "/studyReport/clearReportPhysician/";
  private readonly noPublishWebEndPoint: string = "/studyReport/noPublishWeb/";
  private readonly publishWebEndPoint: string = "/studyReport/publishWeb/";

  private readonly noPublishWebForcedEndPoint: string =
    "/studyReport/noPublishWebForced/";
  private readonly publishWebForcedEndPoint: string =
    "/studyReport/publishWebForced/";

  private readonly getStudyReportEndPoint: string =
    "/studyReport/studyReportRefreshPdf/";
  private readonly getStudyReportSectionsEndPoint: string =
    "/studyReport/getStudyReportSections/";

  private readonly getStudyReportSearchItemsEndPoint: string =
    "/studyReport/getStudyReportSearchItems/";
  private readonly getStudyReportEditInfoEndPoint: string =
    "/studyReport/getStudyReportEditInfo/";
  private readonly studyReportDirectTypingUpdateEndPoint: string =
    "/studyReport/studyReportDirectTypingUpdate/";
  private readonly studyReportDirectTypingConfirmEndPoint: string =
    "/studyReport/StudyReportDirectTypingConfirm/";
  private readonly getStudyReportTemplateFiltersEndPoint: string =
    "/studyReport/getStudyReportTemplateFilters/";
  private readonly getStudyReportTemplatesTextEndPoint: string =
    "/studyReport/getStudyReportTemplatesText/";
  private readonly getStudyReportReverseReasonsEndPoint: string =
    "/studyReport/getStudyReportReverseReasons/";
  private readonly studyReportReverseEndPoint: string =
    "/studyReport/studyReportReverse/";
  private readonly studyReportUnlockCircuitEndPoint: string =
    "/studyReport/studyReportUnlockCircuit/";
  private readonly studyReportLockEndPoint: string =
    "/studyReport/studyReportLock/";
  private readonly studyReportUnlockEndPoint: string =
    "/studyReport/studyReportUnlock/";
  private readonly getStudyReportTemplateEditEndPoint: string =
    "/studyReport/getStudyReportTemplateEdit/";
  private readonly studyReportTemplateEditUpdateEndPoint: string =
    "/studyReport/studyReportTemplateEditUpdate/";
  private readonly studyReportTemplateEnableEndPoint: string =
    "/studyReport/studyReportTemplateEnable/";
  private readonly studyReportTemplateDeleteEndPoint: string =
    "/studyReport/studyReportTemplateDelete/";
  private readonly getReportRegionViewsEndPoint: string =
    "/studyReport/getReportRegionViews/";
  private readonly getStudyReportStateFiltersEndPoint: string =
    "/studyReport/getStudyReportStateFilters/";
  private readonly studyReportTemplateAssignToProfessionalEndPoint: string =
    "/studyReport/studyReportTemplateAssignToProfessional/";

  private readonly rollbackAdminControledEndPoint: string =
    "/studyReport/rollbackAdminControled/";
  private readonly adminControledEndPoint: string =
    "/studyReport/adminControled/";

  private readonly getStudyReportDeliveryDateEndPoint: string =
    "/studyReport/GetStudyReportDeliveryDate/";

  private readonly getStudyReportSearchItemsForControlEndPoint: string =
    "/studyReport/getStudyReportSearchItemsForControl/";
  private readonly getStudyReportTemplateFiltersByNameEndPoint: string =
    "/studyReport/getStudyReportTemplateFiltersByName/";
  private readonly searchMedicalReportAuditEndPoint: string =
    "/studyReport/SearchMedicalReportAudit/";
  private readonly searchMedicalReportHistorialEndPoint: string =
    "/studyReport/SearchMedicalReportHistorial/";
  private readonly getMedicalReportCategoriesEndPoint: string =
    "/studyReport/GetMedicalReportCategories/";

  private readonly exportDiagnosesEndPoint: string =
    "/studyReport/exportDiagnoses/";
  private readonly setDiagnosesAndExportEndPoint: string =
    "/studyReport/SetDiagnosesAndExport/";
  private readonly setDiagnosesByStudyReportIdEndPoint: string =
    "/studyReport/SetDiagnosesByStudyReportId/";
  private readonly setDiagnosesEndPoint: string = "/studyReport/SetDiagnoses/";

  private readonly studyReportsUnlockEndPoint: string =
    "/studyReport/studyReportsUnlock/";

  async studyReportsUnlock(studyReportIds: number[]): Promise<boolean> {
    const params = { StudyReportIds: studyReportIds };
    return await this.dataService
      .post<boolean>(this.studyReportsUnlockEndPoint, params)
      .toPromise();
  }

  async exportDiagnoses(
    medicalAppointmentProcedureIds: number[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(
        this.exportDiagnosesEndPoint,
        medicalAppointmentProcedureIds
      )
      .toPromise();
  }

  async setDiagnosesAndExport(
    categoryId: number,
    medicalAppointmentId: number,
    studyReportId: number
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.setDiagnosesAndExportEndPoint, {
        CategoryId: categoryId,
        MedicalAppointmentId: medicalAppointmentId,
        StudyReportId: studyReportId,
      })
      .toPromise();
  }

  async setDiagnosesByStudyReportId(
    categoryId: number,
    studyReportId: number
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.setDiagnosesByStudyReportIdEndPoint, {
        CategoryId: categoryId,
        StudyReportId: studyReportId,
      })
      .toPromise();
  }

  async setDiagnoses(
    categoryId: number,
    medicalAppointmentProcedureIds: number[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.setDiagnosesEndPoint, {
        CategoryId: categoryId,
        MedicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
      })
      .toPromise();
  }

  async getStudyReportDeliveryDate(
    medicalAppointmentId: number
  ): Promise<string | null> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
      .get<string | null>(this.getStudyReportDeliveryDateEndPoint, params)
      .toPromise();
  }

  async getReportRegionViews(
    medicalAppointmentId: number
  ): Promise<StudyReportRegionView[]> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService
      .get<StudyReportRegionView[]>(this.getReportRegionViewsEndPoint, params)
      .toPromise();
  }

  async studyReportLock(
    studyReportId: number,
    practiceRegionId: number,
    defaultStudyReportCicuitId: number,
    userId: number
  ): Promise<StudyReportLockInfo> {
    const param = {
      StudyReportId: studyReportId,
      PracticeRegionId: practiceRegionId,
      DefaultStudyReportCicuitId: defaultStudyReportCicuitId,
      UserId: userId,
    };
    return await this.dataService
      .post<StudyReportLockInfo>(this.studyReportLockEndPoint, param)
      .toPromise();
  }

  async studyReportUnlock(studyReportId: number): Promise<boolean> {
    const param = { StudyReportId: studyReportId };
    return await this.dataService
      .post<boolean>(this.studyReportUnlockEndPoint, param)
      .toPromise();
  }

  async studyReportTemplateAssignToProfessional(
    studyReportTemplateIds: number[],
    physicianIds: number[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.studyReportTemplateAssignToProfessionalEndPoint, {
        StudyReportTemplateIds: studyReportTemplateIds,
        PhysicianIds: physicianIds,
      })
      .toPromise();
  }

  async studyReportTemplateDelete(
    studyReportTemplateFilter: StudyReportTemplateFilter
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(
        this.studyReportTemplateDeleteEndPoint,
        studyReportTemplateFilter
      )
      .toPromise();
  }

  async studyReportTemplateEnable(
    studyReportTemplateFilter: StudyReportTemplateFilter
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(
        this.studyReportTemplateEnableEndPoint,
        studyReportTemplateFilter
      )
      .toPromise();
  }

  async studyReportTemplateEditUpdate(
    studyReportTemplateEdit: StudyReportTemplateEdit
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(
        this.studyReportTemplateEditUpdateEndPoint,
        studyReportTemplateEdit
      )
      .toPromise();
  }

  async getStudyReportTemplateEdit(
    studyReportTemplateId: number
  ): Promise<StudyReportTemplateEdit> {
    const params = { studyReportTemplateId: studyReportTemplateId };
    return await this.dataService
      .get<StudyReportTemplateEdit>(
        this.getStudyReportTemplateEditEndPoint,
        params
      )
      .toPromise();
  }

  async getStudyReportTemplateFiltersByName(
    name: string,
    includeDeleted: boolean,
    editorId: number
  ): Promise<StudyReportTemplateFilter[]> {
    const params = { includeDeleted: includeDeleted, name: name, editorId: editorId };
    return await this.dataService
      .get<StudyReportTemplateFilter[]>(
        this.getStudyReportTemplateFiltersByNameEndPoint,
        params
      )
      .toPromise();
  }

  async studyReportUnlockCircuit(
    studyReportSearchItem: StudyReportSearchItem
  ): Promise<StudyReportSearchItem> {
    return await this.dataService
      .post<StudyReportSearchItem>(
        this.studyReportUnlockCircuitEndPoint,
        studyReportSearchItem
      )
      .toPromise();
  }

  async getStudyReportReverseReasons(): Promise<StudyReportReverseReason[]> {
    const params = {};
    return await this.dataService
      .get<StudyReportReverseReason[]>(
        this.getStudyReportReverseReasonsEndPoint,
        params
      )
      .toPromise();
  }

  async getStudyReportPdf(
    studyReportId: number,
    mergeImages: boolean = false
  ): Promise<ReportViewer> {
    const params = { studyReportId, mergeImages };
    return await this.dataService
      .get<ReportViewer>(this.getStudyReportPdfEndPoint, params)
      .toPromise();
  }

  async getStudyReportHistorial(reportFileId: number): Promise<ReportViewer> {
    const params = { reportFileId };
    return await this.dataService
      .get<ReportViewer>(this.getStudyReportHistorialEndPoint, params)
      .toPromise();
  }

  async getStudyReportIdStudiesReportPdf(
    studyReportIds: number[],
    mergeImages: boolean = false
  ): Promise<StudyReportReportViewer[]> {
    const response: StudyReportReportViewer[] = [];

    while (studyReportIds.length > 0) {
      const maxIndex = Math.min(100, studyReportIds.length);
      let ids: number[] = [];

      ids.push(...studyReportIds.slice(0, maxIndex));

      for (let index = 0; index < maxIndex; index++) {
        studyReportIds.splice(0, 1);
      }

      const params = {
        studyReportIds: JSON.stringify(ids),
        mergeImages,
      };

      const items = await this.dataService
        .get<StudyReportReportViewer[]>(
          this.getStudyReportIdStudiesReportPdfEndPoint,
          params
        )
        .toPromise();

      response.push(...items);
    }

    return response;
  }

  async getMergedStudiesReportPdf(
    studyReportIds: number[],
    mergeImages: boolean = false
  ): Promise<ReportViewer> {
    const params = {
      studyReportIds: JSON.stringify(studyReportIds),
      mergeImages,
    };

    return await this.dataService
      .get<ReportViewer>(this.getMergedStudiesReportPdfEndPoint, params)
      .toPromise();
  }

  async getStudiesReportPdf(
    studyReportIds: number[],
    mergeImages: boolean = false
  ) {
    const response: ReportViewer[] = [];

    while (studyReportIds.length > 0) {
      const maxIndex = Math.min(100, studyReportIds.length);
      let ids: number[] = [];

      ids.push(...studyReportIds.slice(0, maxIndex));

      for (let index = 0; index < maxIndex; index++) {
        studyReportIds.splice(0, 1);
      }

      const params = {
        studyReportIds: JSON.stringify(ids),
        mergeImages,
      };

      const items = await this.dataService
        .get<ReportViewer[]>(this.getStudiesReportPdfEndPoint, params)
        .toPromise();

      response.push(...items);
    }

    return response;
  }

  async getStudyReportTemplateFilters(
    physicianId: number,
    studyReportId: number,
    editorId: number
  ): Promise<StudyReportTemplateFilter[]> {
    const params = {
      physicianId: physicianId,
      studyReportId: studyReportId,
      editorId: editorId
    };
    return await this.dataService
      .get<StudyReportTemplateFilter[]>(
        this.getStudyReportTemplateFiltersEndPoint,
        params
      )
      .toPromise();
  }

  async getStudyReportTemplatesText(
    studyReportTemplateIds: number[]
  ): Promise<string[]> {
    const params = {
      studyReportTemplateIds: JSON.stringify(studyReportTemplateIds),
    };
    return await this.dataService
      .get<string[]>(this.getStudyReportTemplatesTextEndPoint, params)
      .toPromise();
  }

  async studyReportDirectTypingConfirm(
    typeModalityEnum: StudyReportTypeModalityEnum,
    studyReportEdit: StudyReportEdit,
    structuredDiagnosisColumnItems: StructuredDiagnosisColumnItem[]
  ): Promise<boolean> {
    studyReportEdit.UserId = this.authService.getUserId();
    const request = {
      TypeModalityEnum: typeModalityEnum,
      StudyReportEdit: studyReportEdit,
      StructuredDiagnosisColumnItems: structuredDiagnosisColumnItems,
    };
    return await this.dataService
      .post<boolean>(this.studyReportDirectTypingConfirmEndPoint, request)
      .toPromise();
  }

  async studyReportReverse(
    studyReportReverse: StudyReportReverse
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.studyReportReverseEndPoint, studyReportReverse)
      .toPromise();
  }

  async studyReportRefreshPdf(
    studyReportEdit: StudyReportEdit
  ): Promise<ReportViewer> {
    studyReportEdit.UserId = this.authService.getUserId();
    return await this.dataService
      .post<ReportViewer>(this.getStudyReportEndPoint, studyReportEdit)
      .toPromise();
  }

  async getStudyReportSections(
    studyReportEdit: StudyReportEdit
  ): Promise<StudyReportSections> {
    // studyReportEdit.UserId = this.authService.getUserId();
    return await this.dataService
      .post<StudyReportSections>(
        this.getStudyReportSectionsEndPoint,
        studyReportEdit
      )
      .toPromise();
  }

  async studyReportDirectTypingUpdate(
    studyReportEdit: StudyReportEdit
  ): Promise<boolean> {

    studyReportEdit.UserId = this.authService.getUserId();
    return await this.dataService
      .post<boolean>(
        this.studyReportDirectTypingUpdateEndPoint,
        studyReportEdit
      )
      .toPromise();
  }

  async getStudyReportEditInfo(
    studyReportId: number
  ): Promise<StudyReportEditInfo> {
    const params = { studyReportId: studyReportId };
    return await this.dataService
      .get<StudyReportEditInfo>(this.getStudyReportEditInfoEndPoint, params)
      .toPromise();
  }

  async getStudyReportStateFilters(): Promise<StudyReportStateFilter[]> {
    const params = {};
    return await this.dataService
      .get<StudyReportStateFilter[]>(
        this.getStudyReportStateFiltersEndPoint,
        params
      )
      .toPromise();
  }

  async getStudyReportAttachedFiles(
    studyReportId: number
  ): Promise<StudyReportAttachedFileView[]> {
    const params = { studyReportId };
    return await this.dataService
      .get<StudyReportAttachedFileView[]>(
        "/studyReport/getStudyReportAttachedFiles/",
        params
      )
      .toPromise();
  }

  async studyReportAttachFile(
    studyReportId: number,
    fileName: string,
    fileBase64: string
  ): Promise<boolean> {
    const params = {
      StudyReportId: studyReportId,
      FileName: fileName,
      FileBase64: fileBase64,
    };

    return await this.dataService
      .post<boolean>("/studyReport/studyReportAttachFile/", params)
      .toPromise();
  }

  async getStudyReportSearchItems(
    protocol: string,
    myStudyReport: boolean,
    seeToInform: boolean,
    seeToCorrect: boolean,
    seeConfirmed: boolean,
    validatePractice: boolean,
    withAdminControled: boolean,
    reAppointment: boolean,
    physicianId?: number,
    studyReportCicuitId?: number,
    from?: Date,
    to?: Date,
    studyReportPhysicianId?: number,
    referringPhysicianId?: number,
    patientId?: number,
    centerId?: number,
    serviceId?: number,
    appointmentDate?: Date,
    orderByPatient?: boolean,
    studyReportRegionId?: number
  ): Promise<StudyReportSearchItem[]> {
    const params = {
      myStudyReport: myStudyReport,
      seeToInform: seeToInform,
      seeToCorrect: seeToCorrect,
      seeConfirmed: seeConfirmed,
      validatePractice: validatePractice,
      withAdminControled: withAdminControled,
      reAppointment: reAppointment,
      physicianId: physicianId,
      studyReportCicuitId: studyReportCicuitId,
      from: from
        ? new Date(
            from.getFullYear(),
            from.getMonth(),
            from.getDate()
          ).toDateString()
        : null,
      to: to
        ? new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString()
        : null,
      protocol: protocol,
      patientId: patientId,
      studyReportPhysicianId: studyReportPhysicianId,
      referringPhysicianId: referringPhysicianId,
      centerId: centerId,
      serviceId: serviceId,
      appointmentDate: appointmentDate
        ? new Date(
            appointmentDate.getFullYear(),
            appointmentDate.getMonth(),
            appointmentDate.getDate()
          ).toDateString()
        : null,
      orderByPatient,
      studyReportRegionId,
    };

    return await this.dataService
      .get<StudyReportSearchItem[]>(
        this.getStudyReportSearchItemsEndPoint,
        params
      )
      .toPromise();
  }

  async getStudyReportSearchItemsForControl(
    protocol: string,
    studyReportStateIds: number[],
    onNoPublish: boolean,
    noReportPhysician: boolean,
    withAdminControled: boolean,
    orderByDeliveryDate: boolean,
    onlyEndAttention: boolean,
    reAppointment: boolean,
    entityIds: number[],
    patientId?: number,
    studyReportRegionId?: number,
    practiceRegionId?: number,
    from?: Date,
    to?: Date,
    medicalAppointmentDate?: Date,
    studyReportPhysicianId?: number,
    centerId?: number,
    serviceId?: number,
    statusPhotographyId?: number,
    noAdminControled?: boolean,
    orderByConfirmDate?: boolean,
    confirmDate?: Date
  ): Promise<StudyReportSearchItem[]> {
    const params = {
      protocol: protocol,
      studyReportStateIds: JSON.stringify(studyReportStateIds),
      entityIds: JSON.stringify(entityIds),
      onNoPublish: onNoPublish,
      noReportPhysician: noReportPhysician,
      withAdminControled: withAdminControled,
      reAppointment: reAppointment,
      orderByDeliveryDate: orderByDeliveryDate,
      onlyEndAttention: onlyEndAttention,
      patientId: patientId,
      studyReportRegionId: studyReportRegionId,
      practiceRegionId: practiceRegionId,
      from: from
        ? new Date(
            from.getFullYear(),
            from.getMonth(),
            from.getDate()
          ).toDateString()
        : null,
      to: to
        ? new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString()
        : null,
      medicalAppointmentDate: medicalAppointmentDate
        ? new Date(
            medicalAppointmentDate.getFullYear(),
            medicalAppointmentDate.getMonth(),
            medicalAppointmentDate.getDate()
          ).toDateString()
        : null,
      studyReportPhysicianId: studyReportPhysicianId,
      centerId: centerId,
      serviceId: serviceId,
      statusPhotographyId: statusPhotographyId,
      noAdminControled: noAdminControled,
      orderByConfirmDate: orderByConfirmDate,
      confirmDate: confirmDate
        ? new Date(
            confirmDate.getFullYear(),
            confirmDate.getMonth(),
            confirmDate.getDate()
          ).toDateString()
        : null,
    };

    return await this.dataService
      .get<StudyReportSearchItem[]>(
        this.getStudyReportSearchItemsForControlEndPoint,
        params
      )
      .toPromise();
  }

  async searchMedicalReportAudit(
    request: SearchMedicalReportAuditRequest
  ): Promise<SearchMedicalReportAuditResponse[]> {
    return await this.dataService
      .post<SearchMedicalReportAuditResponse[]>(
        this.searchMedicalReportAuditEndPoint,
        request
      )
      .toPromise();
  }

  async searchMedicalReportHistorial(
    request: SearchMedicalReportHistorialRequest
  ): Promise<SearchMedicalReportHistorialResponse[]> {
    return await this.dataService
      .post<SearchMedicalReportHistorialResponse[]>(
        this.searchMedicalReportHistorialEndPoint,
        request
      )
      .toPromise();
  }

  async getMedicalReportCategories(): Promise<
    SearchMedicalReportCategory[]
  > {
    return await this.dataService
      .get<SearchMedicalReportCategory[]>(
        this.getMedicalReportCategoriesEndPoint
      )
      .toPromise();
  }

  async publishWebForced(
    studyReportSearchItems: StudyReportSearchItem[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.publishWebForcedEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async noPublishWebForced(
    studyReportSearchItems: StudyReportSearchItem[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.noPublishWebForcedEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async publishWeb(
    studyReportSearchItems: StudyReportSearchItem[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.publishWebEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async noPublishWeb(
    studyReportSearchItems: StudyReportSearchItem[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.noPublishWebEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async sendMailById(studyReportId: number): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.sendMailByIdEndPoint, {
        StudyReportId: studyReportId,
      })
      .toPromise();
  }

  async sendMail(
    studyReportSearchItem: StudyReportSearchItem
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.sendMailEndPoint, studyReportSearchItem)
      .toPromise();
  }

  async sendMassiveMails(
    studyReportSearchItems: StudyReportSearchItem[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.sendMassiveMailsEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async adminControled(
    studyReportSearchItems: AdminControledRequest[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(this.adminControledEndPoint, studyReportSearchItems)
      .toPromise();
  }

  async rollbackAdminControled(
    studyReportSearchItems: AdminControledRequest[]
  ): Promise<boolean> {
    return await this.dataService
      .post<boolean>(
        this.rollbackAdminControledEndPoint,
        studyReportSearchItems
      )
      .toPromise();
  }

  async setReportPhysician(
    physicianId: number,
    reportIds: number[]
  ): Promise<StudyRegionPhycisianResponse> {
    return await this.dataService
      .post<StudyRegionPhycisianResponse>(this.setReportPhysicianEndPoint, {
        PhysicianId: physicianId,
        ReportIds: reportIds,
      })
      .toPromise();
  }

  async clearReportPhysician(
    reportIds: number[]
  ): Promise<StudyRegionPhycisianResponse> {
    return await this.dataService
      .post<StudyRegionPhycisianResponse>(this.clearReportPhysicianEndPoint, {
        ReportIds: reportIds,
      })
      .toPromise();
  }
}
